import React from 'react';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'default',
  className = '',
  ...props 
}) => {
  const baseStyles = 'uppercase tracking-tighter font-bold rounded-none transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 focus:ring-offset-background';
  
  const variants = {
    primary: 'bg-accent text-accent-foreground hover:scale-105 active:scale-95',
    outline: 'border-2 border-border bg-transparent text-foreground hover:bg-foreground hover:text-background',
    ghost: 'bg-transparent text-foreground hover:text-accent',
  };
  
  const sizes = {
    small: 'h-10 px-4 text-sm',
    default: 'h-14 px-8 text-base',
    large: 'h-20 px-12 text-xl',
  };
  
  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;

